/**
 * Avance
 *
 */
import React from 'react'
import { Button, Input, DatePicker, Dropdown, Menu, Spin, Icon, } from 'antd'
import moment from 'moment'
import { Crud } from '../../../../components'
import Api from '../../../../Api'
import Exception from '../../../../Exception'
import numeral from 'numeral'

export class AvanceForm extends React.Component {
  /**
   * constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.state = {
      id: null,
      loading: false,
      fase: this.buildFase(),
      fases: [],

      actividad: {
        cantidad: 0,
        precio: 0,
        medida: '',
      },

      form: this.buildForm(),
    }
  }

  /**
   * componentDidMount
   *
   */
  componentDidMount() {
    if (this.props.actividadId) {
      this.fetch(this.props.actividadId || null, this.props.avanceId || null)
    }
  }

  /**
   * componentWillReceiveProps
   *
   * @param {Object} newProps
   */
  componentWillReceiveProps(newProps) {
    const continuar = (
      newProps.actividadId && (
        this.props.actividadId !== newProps.actividadId ||
        this.props.avanceId !== newProps.avanceId
      )
    )

    if (continuar) {
      this.fetch(newProps.actividadId || null, newProps.avanceId || null)
    }
  }

  buildFase = () => {
    return {
      iId: null,
      sNombre: 'FASE',
      dFraccionPorcentaje: 0,
    }
  }

  /**
   * buildForm
   */
  buildForm = () => {
    return {
      iId: null,
      iIdFase: null,
      dVolumen: null,
      dFecha: moment(),
    }
  }

  /**
   * getActividadFase
   *
   * @param {number} faseId
   */
  getActividadFase = (faseId) => {
    const fase = this.state.fases.find(f => f.iId === faseId)
    return fase
  }

  /**
   * setActividadFase
   *
   * @param {number} faseId
   */
  setActividadFase = (faseId) => {
    const fase = this.getActividadFase(faseId)

    this.setState({
      fase: fase || this.buildFase(),
      form: {
        ...this.state.form,
        iIdFase: fase ? fase.iId : null,
      },
    })
  }

  /**
   * fetch
   *
   * @param {number} actividadId
   * @param {number} avanceId
   */
  fetch = async (actividadId, avanceId) => {
    try {
      this.setState({ loading: true })

      const { data: results } = await Api.query.list({
        avance: {
          __returnType: 'one',
          attributes: [
            'iIdFase',
            'dFecha',
            'dVolumen',
          ],
          include: [{
            as: 'fase',
            required: true,
            attributes: Object.keys(this.buildFase()),
          }],
          model: 'CmrAvance',
          where: {
            iId: avanceId,
            iActivo: true,
          },
        },

        actividad: {
          __returnType: 'one',
          model: 'CmrConceptoAnexo',
          include: [
            {
              as: 'fases',
              required: false,
              attributes: [
                'iId',
                'sNombre',
                'dFraccionPorcentaje',
              ]
            },
          ],
          attributes: [
            'cantidad',
            ['pu_mxn', 'precio'],
            'medida',
          ],
          where: { id: actividadId },
        }
      })

      const { avance, actividad } = results

      const defaultForm = this.buildForm()
      const form = {
        ...defaultForm,
        ...avance,
        dVolumen: avance ? (avance.dVolumen * 1).toString() : defaultForm.dVolumen,
        dFecha: avance ? moment(avance.dFecha, 'YYYY-MM-DD') : defaultForm.dFecha,
      }

      this.setState({
        id: avanceId,
        loading: false,
        fase: avance && avance.fase ? avance.fase : (
          actividad.fases.length === 1 ? actividad.fases[0] : this.buildFase()
        ),
        form: form,
        fases: actividad.fases,
        actividad: actividad,
        // form: this.buildForm(),
      })
    } catch (error) {
      this.setState({
        loading: false,
        fases: [],
        fase: this.buildFase(),
        form: this.buildForm(),
      })
      Exception.load(error).show()
    }
  }

  /**
   * save
   *
   */
  save = () => {
    this.setState({ loading: true })

    const mutation = {
      model: 'CmrAvance',
      values: {
        ...this.state.form,
        dVolumen: this.state.form.dVolumen * 1,
        iIdFase: this.state.fase.iId,
        iIdActividad: this.props.actividadId,
        dFecha: this.state.form.dFecha.format('YYYY-MM-DD'),
        fase: null,
      },
    }

    Api.post('/kernel/mutator', { items: [mutation] })
      .then(response => {
        this.setState({ loading: false })
        this.props.onSave && this.props.onSave(response.data)
      })
      .catch(err => {
        this.setState({ loading: false })
        Exception.load(err).show()
      })
  }

  /**
   * onVolumenChange
   *
   * @param {Event} e
   */
  onVolumenChange = e => {
    const val = typeof e.target.value === 'string' ? e.target.value.trim() : ''

    if (val.length === 0) {
      this.setState({
        form: {
          ...this.state.form,
          dVolumen: null,
        }
      })
      return
    }

    if (/^[0-9]+([,.][0-9]+)?$/.test(val)) {
      this.setState({
        form: {
          ...this.state.form,
          dVolumen: val,
        }
      })
    }
  }

  /**
   * render
   *
   */
  render() {
    const { actividad, fases, form, fase, loading } = this.state

    const crudButtons = ['add']

    if (this.props.avanceId) {
      crudButtons.push('cancel')
    }

    crudButtons.push('reload')

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <DatePicker
          placeholder='Fecha'
          showTime={false}
          mode='date'
          style={{ marginRight: 8 }}
          format='YYYY-MM-DD'
          defaultValue={form.dFecha}
          onChange={(value) => console.log(value)}
        />

        <Dropdown
          icon={<Icon type='compass' style={{ color: 'inherit' }} />}
          overlay={
            <Menu
              onClick={(e) => this.setActividadFase(e.key * 1)}
              children={fases.map(f =>
                <Menu.Item key={f.iId.toString()} children={f.sNombre} />
              )}
            />
          }
          children={
            <Button
              icon='compass'
              children={fase.sNombre}
              style={{ minWidth: 120, marginRight: 8 }}
            />
          }
        />

        <Input
          min={0}
          max={actividad.cantidad}
          placeholder='Volumen AV'
          style={{ marginRight: 8, width: 220 }}
          ref={ref => this.input = ref}
          precision={2}
          addonBefore={<Icon type='thunderbolt' style={{ color: 'inherit' }} />}
          addonAfter={
            <span>
              <Icon type='thunderbolt' style={{ color: 'inherit' }} />
              <span>{numeral((this.state.form.dVolumen * fase.dFraccionPorcentaje) * actividad.precio).format('$0,0.00')}</span>
            </span>
          }
          defaultValue={form.dVolumen}
          value={form.dVolumen}
          onChange={this.onVolumenChange}
        />

        <Crud
          buttons={crudButtons}
          onAdd={() => this.save()}
          onReload={this.props.onReload}
          onCancel={this.props.onCancel}
        />

        {!loading ? null : (
          <div style={{ marginLeft: 3, marginRight: 3, }}>
            <Spin size='small' />
          </div>
        )}
      </div>
    )
  }
}
